import { render, staticRenderFns } from "./PayPalCasesEditing.vue?vue&type=template&id=386f5a78&scoped=true"
import script from "./PayPalCasesEditing.vue?vue&type=script&lang=js"
export * from "./PayPalCasesEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386f5a78",
  null
  
)

export default component.exports